/*
 * Copyright (c) Worldline 2023.
 */

import {Injectable} from '@angular/core';
import {RootScopeService} from "./rootscope.service";
import {EvidenceContentType} from "../constant/evidence-content-type";

@Injectable({
    providedIn: 'root'
})
export class EvidenceUserHelperService {

    private link: any;

    constructor(private rootScope: RootScopeService) {
    }

    evidenceUserHelperState(evidenceType, partName, contentType) {
        var image = this.getImage(evidenceType, partName, contentType);
        var text = this.getText(evidenceType, partName, contentType);
        var evidenceUserHelperAvailable = true;

        //If previous variables are not defined or null
        if (typeof (image) === 'undefined' || image === null) {
            image = null;
        }
        if (typeof (text) === 'undefined' || text === null) {
            text = null;
        }
        if (text === null && image === null) {
            evidenceUserHelperAvailable = false;
        }

        //Set result object
        return {
            image: image,
            text: text,
            evidenceUserHelperAvailable: evidenceUserHelperAvailable
        };
    };

    getImage(evidenceType, partName, contentType) {
        var key;
        if (contentType === EvidenceContentType.NAMED_PARTS) {
            key = evidenceType + '-' + partName;
        } else {
            key = evidenceType;
        }
        //evidenceUserHelper.json data are gotten into session service
        return this.rootScope.get().evidenceUserHelperMap[key];
    }

    getText(evidenceType, partName, contentType) {
        var key;
        if (contentType === EvidenceContentType.NAMED_PARTS) {
            key = 'evidences.popover.' + evidenceType + '-' + partName;
        } else {
            key = 'evidences.popover.' + evidenceType;
        }
        return key;
    }

    createPopoverTable() {
        this.rootScope.get().popoverTable = [];
    };

    changePopoverStatus(helpButtonId) {
        for (var key in this.rootScope.get().popoverTable) {
            if (typeof this.rootScope.get().popoverTable[key] !== 'function') {
                if (key !== helpButtonId) {
                    this.rootScope.get().popoverTable[key] = false;
                } else {
                    if (this.rootScope.get().popoverTable[key] === true) {
                        this.rootScope.get().popoverTable[key] = false;
                    } else {
                        this.rootScope.get().popoverTable[key] = true;
                    }
                }
            }
        }
    };

    registerPopoverButton(key) {
        this.rootScope.get().popoverTable[key] = false;
    };

    closeAll() {
        for (var key in this.rootScope.get().popoverTable) {
            if (typeof this.rootScope.get().popoverTable[key] !== 'function') {
                this.rootScope.get().popoverTable[key] = false;
            }
        }
    };

}
